module.exports = __webpack_public_path__ + "img/p1-desc.86c0038f.jpg";